module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_rogaland_pos.b336eeb0.svg";